import { render, staticRenderFns } from "./saveSubscription.vue?vue&type=template&id=04d8b738&scoped=true"
import script from "./saveSubscription.vue?vue&type=script&lang=js"
export * from "./saveSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8b738",
  null
  
)

export default component.exports